
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/picks",
      function () {
        return require("private-next-pages/[league]/picks/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/picks"])
      });
    }
  